import { render, staticRenderFns } from "./sjjy4.vue?vue&type=template&id=635113f4&scoped=true&"
import script from "./sjjy4.vue?vue&type=script&lang=js&"
export * from "./sjjy4.vue?vue&type=script&lang=js&"
import style0 from "./sjjy4.vue?vue&type=style&index=0&id=635113f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635113f4",
  null
  
)

export default component.exports